module.exports = __webpack_public_path__ + "media/application/images/svgs/eye-off-f6be5c44484168e279dabfd0417c78b8.svg";